import React, { useState, useEffect, useContext } from 'react'
import { Box, Anchor, Text, Button } from "grommet"

import TTJsonTree from '../common/TTJsonTree'
import Spinner from '../common/Spinner'
import TriageUrlContext from '../../context/TriageUrlContext'

import axios from 'axios'

import { gql, useSubscription } from '@apollo/client';

import TTCopyClipboard from '../common/TTCopyClipboard'


import TriageFile from './TriageFile'

import { TopBar, TopBarFile } from './TriageViewUtils'
import { FormStatusNotification } from '../common/FormStatusNotification'
import { useDefaultConf } from './TriageHeaders'

const TASK_QUERY = gql`
subscription($taskId: String!) {
    jobtask(where: {taskid: {_eq: $taskId}}) {
        taskid
        result
        status
      }
}
`

const TriageViewResult = ({ content }) => {

    const [result, setResult] = useState(false)
    const [resultURL, setResultURL] = useState(false)
    const [state, setState] = useState(false)

    const t3_url = useContext(TriageUrlContext)

    const { data: taskResult, loading: taskDataLoading } = useSubscription(
        TASK_QUERY, { variables: { taskId: content.taskid } }
    )

    const axiosConf = useDefaultConf()

    let t3TaskStatus = t3_url + '/api/1/taskstatus/' + content.taskid

    useEffect(() => {

        async function getStatusResponse() {

            const response = await axios(t3TaskStatus, axiosConf)
    
            if (response.status === 200) {
                if (response.data.state === "SUCCESS") {
                    setResult(response.data)
                    setResultURL(response.config.url)
                    setState(response.data.state)
                    return null
                }
                if (response.data.state === "PENDING") {
                    setResult(response.data)
                    setResultURL(response.config.url)
                    setState(response.data.state)
                    return null
                }
                if (response.data.state === "FAILURE") {
                    setResult(response.data)
                    setResultURL(response.config.url)
                    setState(response.data.state)
                    return null
                }
            }
    
        }

        if (!taskDataLoading && taskResult && taskResult.jobtask &&
            taskResult.jobtask.length > 0 && taskResult.jobtask[0].status !== 0
            && !(content.taskid.includes("MANUAL")) && state === false
        ) {
            getStatusResponse()
        }
    }, [axiosConf, taskDataLoading, taskResult, state, t3TaskStatus, content.taskid])


    const urlLink = '/triage/showtask/' + content.taskid

    return (
        <>
            <Box margin={{ left: '20px', top: '20px', right: '20px', bottom: '20px' }} gap="small">

                <Box direction="row" gap="small">

                    <Box>
                        <Text weight='bold'>Triage Response</Text>
                    </Box>

                    <Box
                        pad="none"
                        gap="none"
                        margin={{ left: "10px" }}
                        background="brand"
                        round="xsmall"
                        height="25px"
                    >
                        <Anchor margin={{ left: "6px", right: "6px" }} href={urlLink} target="_blank">
                            <Button plain label={<Text color="white" size="12px" weight="normal">Sharable Link</Text>} margin={{ top: "xxsmall" }} hoverIndicator={{ color: "light-1", opacity: "weak" }} />
                        </Anchor>
                    </Box>

                    <Box
                        pad="none"
                        gap="none"
                        height="25px"
                        margin={{ left: "5px" }}
                        align="center"
                    >
                        <TTCopyClipboard copyText={window.location.protocol + '//' + window.location.host + urlLink} />
                    </Box>

                </Box>

                {((content && content.taskid && (content.taskid.includes("MANUAL")) && result) || taskDataLoading) &&
                    <Spinner />
                }

                {
                    !resultURL &&
                    <Spinner />
                }

                <Box margin={{ top: "small" }}>
                    {
                        !content.taskid.includes("MANUAL") && resultURL &&
                        <Box direction="row" align="center">
                            <Anchor label={<Text size="small">{resultURL}</Text>} key={resultURL} href={resultURL} target="_blank" />
                            <TTCopyClipboard copyText={resultURL} />
                        </Box>
                    }

                    {result && result.results &&
                        !result.results.triage_files &&
                        <TopBar text={JSON.stringify(result)} />
                    }
                </Box>

                <Box height="80%">
                    {taskResult && taskResult.jobtask &&
                        taskResult.jobtask.length > 0 && taskResult.jobtask[0].status && taskResult.jobtask[0].status !== 0 &&
                        taskResult.jobtask[0].result && taskResult.jobtask[0].result.length > 0 &&
                        <FormStatusNotification
                            header="Encountered An Error Message From Triage REST API"
                            subheader={taskResult.jobtask[0].result}
                            error={true}
                        />
                    }
                    {!taskDataLoading && content.taskid && content.taskid.indexOf("MANUAL") !== -1 && taskResult && taskResult.jobtask &&
                        taskResult.jobtask.length > 0 && taskResult.jobtask[0].status && taskResult.jobtask[0].status !== 0 &&
                        // IF MANUAL and Status is not in progress -> Show result from DB
                        <TTJsonTree data={taskResult.jobtask[0].result} expandAll={true} />
                    }

                    {!taskDataLoading && content.taskid && content.taskid.indexOf("MANUAL") === -1 && result &&
                        result.results && !result.results.triage_files &&
                        // IF NOT MANUAL -> Get Result from API
                        <TTJsonTree data={result} expandAll={true} />
                    }
                    {!taskDataLoading && content.taskid && content.taskid.indexOf("MANUAL") === -1 && result &&
                        result.state && result.state === "FAILURE" &&
                        // SHOW FAILURES
                        <TTJsonTree data={result} expandAll={true} />
                    }
                    {!taskDataLoading && content.taskid && content.taskid.indexOf("MANUAL") === -1 && taskResult &&
                        taskResult.jobtask[0] && taskResult.jobtask[0].status === 1 && result && result.results &&
                        result.results.triage_files &&
                        //  IF MANUAL and Status is Completed AND Have Files -> Get Result from API
                        result.results.triage_files.map(resultFile => (
                            <>
                                <TopBarFile triageFileUrl={resultFile} />
                                <TriageFile key={resultFile} triageFileUrl={resultFile} />
                            </>
                        ))
                    }
                </Box>
            </Box>
        </>
    )
}

export default TriageViewResult